import {
  EXPAND_REPOSITORY,
  COLLAPSE_REPOSITORY,
  HIDE_REPOSITORY,
  SHOW_REPOSITORY,
  FULL_VIEW_REPOSITORY,
} from '../constants/action-types';

export const expandRepository = () => ({
  type: EXPAND_REPOSITORY,
});

export const collapseRepository = () => ({
  type: COLLAPSE_REPOSITORY,
});

export const hideRepository = () => ({
  type: HIDE_REPOSITORY,
});

export const showRepository = () => ({
  type: SHOW_REPOSITORY,
});

export const fullViewRepository = () => ({
  type: FULL_VIEW_REPOSITORY,
});
